/**
 * Returns whether the provided firmware version is before the target version.
 */
export const isFirmwareBefore = (version: string, target: string) => {
  if (getNumber(version) < getNumber(target)) {
    return true;
  }

  if (getNumber(version) === getNumber(target)) {
    const targetLetter = getLetter(target);
    return !!targetLetter && (getLetter(version) as string) < targetLetter;
  }

  return false;
};

const getNumber = (version: string) => {
  return parseInt(version);
};

const getLetter = (version: string) => {
  return version.length === 4 ? version[3] : null;
};
